// import { Tag, Typography } from 'antd';
// import styles from '.././../Dashboard/index.module.less';
// const { Text, Title } = Typography;

// export default function PrevTaskCard({ type, data }) {
//   return (
//     <div
//       className={
//         ' w-full !rounded-lg py-2 px-3 flex justify-between sm:flex-row flex-col items-start sm:items-center'
//       }
//       style={{
//         borderLeft: '4px solid',
//         borderColor: data.isHighlighted ? '#facc15' : '#0653fa',
//         backgroundColor: data.isHighlighted ? '#fefce8' : 'white'
//       }}
//     >
//       <div className="w-full">
//         <div className="flex items-center justify-between gap-6">
//           <Title level={5} className={styles.taskTitle} style={{ margin: 0 }}>
//             {data.title}
//           </Title>

//           <div className="">
//             {type === 'completed' ? (
//               <Tag className="!text-[10px] !px-1" color="success">
//                 Completed
//               </Tag>
//             ) : (
//               <Tag className="!text-[10px] !px-1" color="error">
//                 Not Completed
//               </Tag>
//             )}
//           </div>
//         </div>
//         <div className="">
//           <Text type="secondary" className={styles.descriptionText}>
//             {data.description}
//           </Text>
//         </div>
//         <div className="flex items-center justify-between gap-6 ">
//           <div>
//             <Text type="secondary" className={styles.secondaryText}>
//               {data.client.client_name} · {data.project.project} ·{' '}
//               {`T${data.id}`}
//             </Text>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useEffect, useRef, useState } from 'react';
import { Tag, Typography } from 'antd';
import { RedoOutlined, RollbackOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
// import { releasePlanTask } from '../redux/slice';
import { updateRelease } from 'pages/AllEmployeeTasks/redux/slice';
import styles from '.././../Dashboard/index.module.less';

const { Text, Title } = Typography;

const statusPopupStyle = {
  position: 'absolute',
  top: '28px',
  right: 0,
  minWidth: '80px',
  background: '#ffffff',
  borderRadius: '6px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  zIndex: 100,
  fontSize: '12px',
  cursor: 'pointer'
};

export default function PrevTaskCard({ type, data, onRefresh }) {
  const dispatch = useDispatch();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);
  console.log(data);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isPopupOpen &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setIsPopupOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isPopupOpen]);

  const handleRelease = (plan_id) => {
    const payload = { plan_id };

    dispatch(updateRelease(payload)).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setIsPopupOpen(false);
        onRefresh?.();
      }
    });
  };
  return (
    <div
      className={
        ' w-full !rounded-lg py-2 px-3 flex justify-between sm:flex-row flex-col items-start sm:items-center'
      }
      style={{
        borderLeft: '4px solid',
        borderColor: data.isHighlighted ? '#facc15' : '#0653fa',
        backgroundColor: data.isHighlighted ? '#fefce8' : 'white'
      }}
    >
      <div className="w-full">
        <div className="flex items-center justify-between gap-6">
          <Title level={5} className={styles.taskTitle} style={{ margin: 0 }}>
            {data.title}
          </Title>

          <div
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            ref={popupRef}
          >
            {type === 'completed' ? (
              <Tag className="!text-[10px] !px-1" color="success">
                Completed
              </Tag>
            ) : (
              <>
                <Tag
                  className="!text-[10px] !px-1"
                  color="error"
                  style={{
                    cursor: data.isReleased ? 'default' : 'pointer'
                  }}
                  onClick={
                    data.isReleased ? undefined : () => setIsPopupOpen(true)
                  }
                >
                  Not Completed
                </Tag>

                {!data.isReleased && isPopupOpen && (
                  <div style={statusPopupStyle}>
                    <div
                      onClick={() => handleRelease(data.plan_id)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '2px 4px',
                        justifyContent: 'center'
                      }}
                    >
                      <RollbackOutlined style={{ color: '#1677ff' }} /> Release
                    </div>
                  </div>
                )}
              </>
            )}
            {data.isReleased && (
              <Tag
                bordered={false}
                className="!m-0 !text-[10px] !px-1"
                color="cyan"
              >
                Released
              </Tag>
            )}
          </div>
        </div>
        <div className="">
          <Text type="secondary" className={styles.descriptionText}>
            {data.description}
          </Text>
        </div>
        <div className="flex items-center justify-between gap-6 ">
          <div>
            <Text type="secondary" className={styles.secondaryText}>
              {data.client.client_name} · {data.project.project} ·{' '}
              {`T${data.id}`}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
